import '../App.css'
import './Page.css';
import { useEffect } from 'react'
import Navbar from '../components/Navbar'
import Home from '../components/Home'
import Services from '../components/Services'
import Skills from '../components/Skills'
import Projects from '../components/Projects'
// import Embeded from '../components/Embeded'
import Certificates from '../components/Certificates'
import Contact from '../components/contact'
import Footer from '../components/Footer'
import Aos from "aos";
import "aos/dist/aos.css";
import About from '../components/about'



function Page() {
  useEffect(() => {
    Aos.init({ duration: 2000, offset: 200 });
  }, []);

  return (
    <div className="main-container">
      <Navbar/>
      <Home />
      <Services />
      <Skills />
      <Projects />
      {/* <Embeded /> */}
      <Certificates/>
      <About/>
      <Contact/>
      <Footer />
    </div>
  );
}

export default Page;